import { render, staticRenderFns } from "./BaseModalFooter.vue?vue&type=template&id=dc5d7080&scoped=true&"
import script from "./BaseModalFooter.vue?vue&type=script&lang=js&"
export * from "./BaseModalFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalFooter.vue?vue&type=style&index=0&id=dc5d7080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d7080",
  null
  
)

export default component.exports